import React from "react";
import { Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import palette from "src/theme/palette";
import dayjs from "dayjs";
import { RENEWAL_WARNING_DAYS_THRESHOLD } from "./SubscriptionTab.consts";

const DetailsCard = styled(Stack)({
  border: "1px solid",
  borderColor: palette.grey[200],
  backgroundColor: palette.system[0],
  borderRadius: 8,
  padding: "16px 18px",
  flexDirection: "row",
  gap: 24
});

const DetailColumn = ({ label, value, valueColor }) => (
  <Stack flex={1} gap="2px">
    <Typography variant="body2" color="text.700">
      {label}
    </Typography>
    <Typography variant="subtitle2" sx={{ color: valueColor || palette.text[800] }}>
      {value || "—"}
    </Typography>
  </Stack>
);

const SubscriptionDetails = ({ opportunity }) => {
  const renewalDate = opportunity.renewalDate ? dayjs(opportunity.renewalDate) : null;
  const daysUntilRenewal = renewalDate ? renewalDate.diff(dayjs(), "day") : null;
  const isRenewalWarning = daysUntilRenewal !== null && daysUntilRenewal <= RENEWAL_WARNING_DAYS_THRESHOLD;

  const contractTermDisplay = opportunity.contractTermMonths
    ? opportunity.contractTermMonths >= 12
      ? `${Math.round(opportunity.contractTermMonths / 12)} years`
      : `${opportunity.contractTermMonths} months`
    : null;

  return (
    <Stack gap="12px">
      <Typography variant="subtitle2">Subscription Details</Typography>
      <DetailsCard>
        <DetailColumn
          label="Renewal date"
          value={renewalDate ? renewalDate.format("MMMM D, YYYY") : null}
        />
        <DetailColumn
          label="Days until renewal"
          value={daysUntilRenewal !== null ? (daysUntilRenewal > 0 ? `${daysUntilRenewal} days` : "Expired") : null}
          valueColor={isRenewalWarning ? palette.warning[700] : undefined}
        />
        <DetailColumn
          label="Contract term"
          value={contractTermDisplay}
        />
      </DetailsCard>
    </Stack>
  );
};

export default SubscriptionDetails;
